import { render } from "./SearchMatrimonyListing.vue?vue&type=template&id=b593863e&scoped=true"
import script from "./SearchMatrimonyListing.vue?vue&type=script&lang=js"
export * from "./SearchMatrimonyListing.vue?vue&type=script&lang=js"

import "./SearchMatrimonyListing.vue?vue&type=style&index=0&id=b593863e&scoped=true&lang=css"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b593863e"]])

export default __exports__